let listeners = [];
let uid = 0;

const toast = (message, type = 'success') => {
  const id = ++uid;
  listeners.forEach(fn => fn({ id, message, type }));
};

toast.success = (message) => toast(message, 'success');
toast.error   = (message) => toast(message, 'error');
toast.info    = (message) => toast(message, 'info');

export const subscribeToast = (fn) => {
  listeners.push(fn);
  return () => { listeners = listeners.filter(l => l !== fn); };
};

export default toast;
